export default [
  {
    path: '404',
    component: () => import('./404')
  },
  {
    path: '', // 有先后顺序，精确的路由放在前面，path为空的放在下面
    component: () => import('../../layouts/inner'),
    children: [
      {
        path: 'noPermission',
        component: () => import('./noPermission')
      }
    ]
  }
]
